import React, { ReactElement, useEffect, useState } from 'react';
import './DocumentCard.less';
import { Tooltip } from 'antd';
import { APPROVED, PENDING } from '../../../shared/constants/commonConstants';
import { IN_COMPLETE } from './../../../shared/constants/commonConstants';
import { ReactComponent as ApprovedIcon } from '../../../assets/images/svg/i_approved.svg';
import { ReactComponent as RejectedIcon } from '../../../assets/images/svg/i_rejected.svg';
import { ReactComponent as PendingIcon } from '../../../assets/images/svg/i_pending.svg';

interface IProps {
  documentCount: any;
  details?: any;
  openUploadModal: any;
}

const DocumentCard = ({ details, openUploadModal }: IProps): ReactElement => {
  const [isApproved, setIsApproved] = useState(APPROVED);

  const dataValidationAndCollection = (): void => {
    const docs = [] as any;
    if (details && details.length > 0) {
      details.forEach((item: any): any => {
        if (item.docName && item.docId) {
          docs.push(item.docName);
          if (!item.isApproved) {
            setIsApproved(PENDING);
          }
        } else {
          setIsApproved(IN_COMPLETE);
        }
      });
    }
  };

  useEffect((): void => {
    dataValidationAndCollection();
    // eslint-disable-next-line
  }, []);

  return (
    <div onClick={(): any => openUploadModal(true, details)} className="document-card-wraper width-size">
      <div className="document-card">
        <p className="m-0">
          <Tooltip placement="right" title={details[0].displayTypeName}>
            <strong className="tag-name">{details[0].displayTypeName}</strong>
          </Tooltip>
        </p>
        <p className="fsize_sm mt-0">{`Validity - ${details.verifiedOn ? details.verifiedOn : 'NA'}`}</p>
      </div>
      <div className={isApproved === APPROVED ? 'document-footer verified' : isApproved === IN_COMPLETE ? 'document-footer incomplete' : 'document-footer pending'}>
        <p className="fsize_sm m-0">
          <strong>{details.length > 0 && details[0].docId ? details.length : 0} Documents</strong>
        </p>
        {isApproved === APPROVED && <div className="status verified">
          <ApprovedIcon className="fill-approved v-align-sub" /> Verified
        </div>}
        {isApproved === IN_COMPLETE && <div className="status incomplete">
          <RejectedIcon className="fill-rejected v-align-sub" /> Incomplete
        </div>}
        {isApproved === PENDING && <div className="status pending">
          <PendingIcon className="fill-pending v-align-sub" /> Pending
        </div>}
      </div>
    </div>
  );
};

export default DocumentCard;
